import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Icon_Facebook",
  "use": "Icon_Facebook-usage",
  "viewBox": "0 0 42 42",
  "content": "<symbol viewBox=\"0 0 42 42\" id=\"Icon_Facebook\">\n<path d=\"M17.177,36h6.107V20.873h4.262L28,15.807h-4.716v-2.883c0-1.194,0.243-1.666,1.41-1.666H28V6h-4.229\n\tc-4.546,0-6.594,1.981-6.594,5.77v4.037H14v5.13h3.177V36z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./frontend/assets/icons/Icon_Facebook.svg
// module id = 104
// module chunks = 0